import axios from 'axios';
import * as Constants from 'constants/Constants';
import { SHOW_DANGER_BAR, SHOW_SUCCESS_BAR } from '../../../../store/actions/types';
import * as Types from '../../../TrustCenter/store/actions/types';
import { getAccountId } from 'components/Common/Utils/ResourceUtils';
export const saveCarrierConfig = (type = Constants.FOURKITES, carrierConfig) => {
    return (dispatch, getState) => {
        const { sessionValue } = getState().session;
        const carrierConfigURL = `https://${
            Constants.TRUSTCENTER_ENDPOINT
        }/integration/titan/v1/${type.toLowerCase()}-carrier-configuration`;
        const tenant_id = sessionValue.tenant_id;
        const user_id = sessionValue.userId;
        const company_id = sessionValue.people_net_id;
        const account_id = getAccountId(getState);

        const headers = {
            user_id,
            tenant_id,
            company_id,
            account_id,
            Authorization: 'Bearer ' + sessionStorage.getItem('access_token')
        };
        dispatch({
            type: Types.DISABLE_AGREEMENT_OPERATIONS
        });
        dispatch(toggleSpinner(true));
        axios
            .post(carrierConfigURL, carrierConfig, {
                headers
            })
            .then((response) => {
                dispatch({
                    type: SHOW_SUCCESS_BAR,
                    payload: 'Carrier Config Created Successfully'
                });
                if (response.data !== undefined) {
                    dispatch({
                        type: Types.ADD_CARRIER_CONFIG,
                        payload: response.data
                    });
                    dispatch({
                        type: Types.CARRIER_CONFIG_EXIST
                    });
                }
            })
            .catch((error) => {
                if (error.response.status !== 401) {
                    dispatch({
                        type: SHOW_DANGER_BAR,
                        payload: 'Error while creating a carrier config'
                    });
                }
            })
            .finally(() => {
                dispatch({
                    type: Types.ENABLE_AGREEMENT_OPERATIONS
                });
                dispatch(toggleSpinner(false));
            });
    };
};

export const updateCarrierConfig = (type = Constants.FOURKITES, carrierConfig) => {
    return (dispatch, getState) => {
        const { sessionValue } = getState().session;
        const carrierConfigURL = `https://${
            Constants.TRUSTCENTER_ENDPOINT
        }/integration/titan/v1/${type.toLowerCase()}-carrier-configuration`;
        const tenant_id = sessionValue.tenant_id;
        const user_id = sessionValue.userId;
        const company_id = sessionValue.people_net_id;
        const account_id = getAccountId(getState);

        const headers = {
            user_id,
            tenant_id,
            company_id,
            account_id,
            Authorization: 'Bearer ' + sessionStorage.getItem('access_token')
        };
        dispatch(toggleSpinner(true));
        axios
            .put(carrierConfigURL, carrierConfig, {
                headers
            })
            .then((response) => {
                dispatch({
                    type: SHOW_SUCCESS_BAR,
                    payload: 'Carrier Config Updated Successfully'
                });
                if (response.data !== undefined) {
                    dispatch({
                        type: Types.ADD_CARRIER_CONFIG,
                        payload: response.data
                    });
                    dispatch({
                        type: Types.CARRIER_CONFIG_EXIST
                    });
                }
            })
            .catch((error) => {
                if (error.response.status !== 401) {
                    dispatch({
                        type: SHOW_DANGER_BAR,
                        payload: 'Error while updating a carrier config'
                    });
                }
            })
            .finally(() => {
                dispatch(toggleSpinner(false));
            });
    };
};

export const createShipperConfig = (shipperConfig) => {
    return (dispatch, getState) => {
        const { sessionValue } = getState().session;
        const shipperConfigURL = `https://${Constants.TRUSTCENTER_ENDPOINT}/integration/titan/v1/macropoint-shipper-configuration/shipperConfig`;
        const tenant_id = sessionValue.tenant_id;
        const user_id = sessionValue.userId;
        const company_id = sessionValue.people_net_id;
        const account_id = getAccountId(getState);

        const headers = {
            user_id,
            tenant_id,
            company_id,
            account_id,
            Authorization: 'Bearer ' + sessionStorage.getItem('access_token')
        };
        dispatch({
            type: Types.DISABLE_AGREEMENT_OPERATIONS
        });
        axios
            .post(shipperConfigURL, shipperConfig, {
                headers
            })
            .then((response) => {
                dispatch({
                    type: SHOW_SUCCESS_BAR,
                    payload: 'Shipper Config Created Successfully'
                });
                dispatch(getShipperConfig());
            })
            .catch((error) => {
                if (error.response.status !== 401) {
                    dispatch({
                        type: SHOW_DANGER_BAR,
                        payload: 'Error while creating a shipper config'
                    });
                }
            })
            .finally(() => {
                dispatch({
                    type: Types.ENABLE_AGREEMENT_OPERATIONS
                });
            });
    };
};

export const updateShipperConfig = (shipperConfig) => {
    return (dispatch, getState) => {
        const { sessionValue } = getState().session;
        const shipperConfigURL = `https://${Constants.TRUSTCENTER_ENDPOINT}/integration/titan/v1/macropoint-shipper-configuration`;
        const tenant_id = sessionValue.tenant_id;
        const user_id = sessionValue.userId;
        const company_id = sessionValue.people_net_id;
        const account_id = getAccountId(getState);

        const headers = {
            user_id,
            tenant_id,
            company_id,
            account_id,
            Authorization: 'Bearer ' + sessionStorage.getItem('access_token')
        };
        dispatch({
            type: Types.DISABLE_AGREEMENT_OPERATIONS
        });
        dispatch(resetShipperConfig());
        axios
            .put(shipperConfigURL, shipperConfig, {
                headers
            })
            .then((response) => {
                dispatch({
                    type: SHOW_SUCCESS_BAR,
                    payload: 'Shipper Config Updated Successfully'
                });
                dispatch({
                    type: Types.ADD_SHIPPER_CONFIG,
                    payload: response?.data
                });
                dispatch(getShipperConfig());
            })
            .catch((error) => {
                if (error.response.status !== 401) {
                    dispatch({
                        type: SHOW_DANGER_BAR,
                        payload: 'Error while updating a shipper config'
                    });
                }
            })
            .finally(() => {
                dispatch({
                    type: Types.ENABLE_AGREEMENT_OPERATIONS
                });
            });
    };
};

export const getShipperConfig = () => {
    return (dispatch, getState) => {
        const shipperConfigURL = `https://${Constants.TRUSTCENTER_ENDPOINT}/integration/titan/v1/macropoint-shipper-configuration`;
        const { sessionValue } = getState().session;
        const accountUuid = sessionValue?.accountUuid;
        const headers = {
            Authorization: 'Bearer ' + sessionStorage.getItem('access_token')
        };
        const params = {
            pageSize: 999,
            query: `accountId==${accountUuid}`
        };
        dispatch(resetAllShipperConfigs());
        axios
            .get(shipperConfigURL, {
                headers,
                params
            })
            .then((response) => {
                if (response?.data !== undefined) {
                    const shipperConfigs = response?.data?.items;
                    dispatch({
                        type: Types.ADD_ALL_SHIPPER_CONFIG,
                        payload: shipperConfigs
                    });
                }
            })
            .catch((error) => {
                if (error?.response?.status !== 401) {
                    dispatch({
                        type: SHOW_DANGER_BAR,
                        payload: 'Error while retreiving a Shipper config'
                    });
                }
            });
    };
};

export const saveShipperConfig = (shipperConfig, callBack) => {
    return (dispatch, getState) => {
        const { sessionValue } = getState().session;
        const shipperConfigUrl = `https://${Constants.TRUSTCENTER_ENDPOINT}/integration/titan/v1/macropoint-shipper-configuration`;
        const tenant_id = sessionValue.tenant_id;
        const user_id = sessionValue.userId;
        const company_id = sessionValue.people_net_id;
        const account_id = getAccountId(getState);
        const accountUuid = sessionValue?.accountUuid;

        const headers = {
            user_id,
            tenant_id,
            company_id,
            account_id,
            Authorization: 'Bearer ' + sessionStorage.getItem('access_token')
        };
        const params = {
            query: `accountId==${accountUuid};shipperCode==${shipperConfig?.shipperCode};dataSourceId==${shipperConfig?.dataSourceId}`
        };
        dispatch(resetShipperConfig());
        dispatch({
            type: Types.DISABLE_AGREEMENT_OPERATIONS
        });
        axios
            .get(shipperConfigUrl, {
                headers,
                params
            })
            .then((response) => {
                if (response.data !== undefined && response.data?.items.length > 0) {
                    dispatch({
                        type: SHOW_SUCCESS_BAR,
                        payload: 'Shipper Config Already Exists'
                    });
                    dispatch({
                        type: Types.ADD_ALL_SHIPPER_CONFIG,
                        payload: response.data.items
                    });
                } else {
                    dispatch(createShipperConfig(shipperConfig, callBack));
                }
            })
            .catch((error) => {
                if (error.response?.status !== 401) {
                    dispatch({
                        type: SHOW_DANGER_BAR,
                        payload: 'Error while fetching a Shipper config'
                    });
                }
            })
            .finally(() => {
                dispatch({
                    type: Types.ENABLE_AGREEMENT_OPERATIONS
                });
                callBack();
            });
    };
};

export const deleteShipperConfig = (shipperConfigId, callBack) => {
    return (dispatch, getState) => {
        const { sessionValue } = getState().session;
        const shipperConfigURL = `https://${Constants.TRUSTCENTER_ENDPOINT}/integration/titan/v1/macropoint-shipper-configuration/${shipperConfigId}`;
        const tenant_id = sessionValue.tenant_id;
        const user_id = sessionValue.userId;
        const company_id = sessionValue.people_net_id;
        const account_id = getAccountId(getState);

        const headers = {
            user_id,
            tenant_id,
            company_id,
            account_id,
            Authorization: 'Bearer ' + sessionStorage.getItem('access_token')
        };
        dispatch({
            type: Types.DISABLE_AGREEMENT_OPERATIONS
        });
        axios
            .delete(shipperConfigURL, {
                headers
            })
            .then((response) => {
                if (callBack) {
                    callBack();
                }
                dispatch({
                    type: SHOW_SUCCESS_BAR,
                    payload: 'Shipper Config deleted Successfully'
                });
            })
            .catch((error) => {
                if (error.response?.status !== 401) {
                    dispatch({
                        type: SHOW_DANGER_BAR,
                        payload: 'Error while deleting a Shipper config'
                    });
                }
            })
            .finally(() => {
                dispatch({
                    type: Types.ENABLE_AGREEMENT_OPERATIONS
                });
            });
    };
};

export const getCarrierConfig = (type = Constants.FOURKITES, selectedAccount) => {
    return (dispatch, getState) => {
        const { sessionValue } = getState().session;
        const carrierConfigURL = `https://${
            Constants.TRUSTCENTER_ENDPOINT
        }/integration/titan/v1/${type.toLowerCase()}-carrier-configuration`;
        const userRole = sessionValue.userRole;
        const accountUuid =
            userRole === Constants.SYSTEM_ADMIN ? selectedAccount?.id : sessionValue?.accountUuid;
        const params = {
            query: `accountId==${accountUuid}`
        };
        dispatch(resetCarrierConfig());
        dispatch({
            type: Types.RESET_CARRIER_CONFIG_EXIST
        });
        axios
            .get(carrierConfigURL, {
                params
            })
            .then((response) => {
                if (response?.data?.items?.length > 0) {
                    dispatch({
                        type: Types.CARRIER_CONFIG_EXIST
                    });
                    dispatch({
                        type: Types.ADD_CARRIER_CONFIG,
                        payload: response.data.items[0]
                    });
                }
            })
            .catch((error) => {
                if (error.response?.status !== 401) {
                    const message = 'Error while fetching Carrier Config';
                    dispatch({
                        type: SHOW_DANGER_BAR,
                        payload: message
                    });
                }
            })
            .finally(() => {});
    };
};

export const resetShipperConfig = () => (dispatch) => {
    dispatch({
        type: Types.ADD_SHIPPER_CONFIG,
        payload: {
            shipperConfigObj: {}
        }
    });
};

export const resetAllShipperConfigs = () => (dispatch) => {
    dispatch({
        type: Types.ADD_SHIPPER_CONFIG,
        payload: {
            shipperConfigs: []
        }
    });
};

export const resetCarrierConfig = () => (dispatch) => {
    dispatch({
        type: Types.ADD_CARRIER_CONFIG,
        payload: null
    });
};

export const toggleSpinner = (showSpinner) => (dispatch) => {
    dispatch({
        type: Types.TOGGLE_SPINNER,
        payload: showSpinner
    });
};
